class InjectionsHandler {
    injectors = {};
    define(key, factory) {
        if (typeof this.injectors[key] !== 'undefined') {
            throw new Error('Cannot redefine ' + key);
        }
        this.injectors[key] = factory;
    }
    resolve(key) {
        const resolved = this.injectors[key];
        if (resolved) {
            return resolved();
        }
        throw new Error('Cannot resolve nonexisting ' + key);
    }
}
const injector = new InjectionsHandler();
export const define = (key, factory) => injector.define(key, factory);
export const resolve = (key) => injector.resolve(key);
function DepInjMixin(Base) {
    const _deps = {};
    return class WithDependencies extends Base {
        get deps() { return _deps; }
        constructor(...args) {
            super(...args);
            (this.constructor.inject || []).forEach((key) => {
                Object.defineProperty(_deps, key, {
                    get: () => resolve(key),
                    configurable: true,
                });
            });
        }
    };
}
export { DepInjMixin };
export const injectable = (targetOrDescriptor) => {
    if (typeof targetOrDescriptor === 'function') {
        const serviceName = targetOrDescriptor.serviceName || targetOrDescriptor.name;
        if (!serviceName) {
            throw new Error('@injectable only applies to named singleton classes');
        }
        let instance;
        try {
            instance = new targetOrDescriptor();
        }
        catch {
            Promise.resolve().then(() => instance = new targetOrDescriptor()).catch(() => void 0);
        }
        define(serviceName, () => instance || targetOrDescriptor.locate(serviceName));
        return targetOrDescriptor;
    }
};
export const requires = (...args) => {
    return (targetOrDescriptor) => {
        if (typeof targetOrDescriptor === 'function') {
            targetOrDescriptor.inject = [...(targetOrDescriptor.inject || []), ...args];
            return targetOrDescriptor;
        }
        return {
            kind: 'class',
            elements: targetOrDescriptor.elements,
            finisher(target) {
                target.inject = [...(target.inject || []), ...args];
            },
        };
    };
};
//# sourceMappingURL=Dependency.js.map